import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { LOGO_IMG, USERBACK_ICON, USERLOGOUT_ICON } from '../../../../utills/image-constant';
import { clearloggedEmployeeReducer } from '../../../../admin/hooks/redux/slice/logged-employee';
import { clearemployeeAccessTokenTokenReducer } from '../../../../admin/hooks/redux/slice/employee-access-token';
import { USERROUTES } from '../../../routes/url-constant';
import { toastEmitter } from '../../../../utills/utilities';
import { userLogout } from '../../../../services/api-services';
import { useNavigate } from 'react-router-dom';

const NewTopBar = () => {
    const [showDropmenu, setShowDropmenu] = useState(false)
    const dispatch = useDispatch();
    const Token = useSelector((state) => state?.employeeAccessToken?.value);
    const navigate = useNavigate();
    useEffect(() => {
        const clickOutside = () => {
            setShowDropmenu(false);
        }
        document.addEventListener('click', clickOutside);
        return () => document.removeEventListener('click', clickOutside);
    }, []);

    const handleLogout = async () => {
        try {
            const response = await userLogout(Token);
            if (response?.status === 200) {
                toastEmitter("success", "User Logout Successfully");
                dispatch(clearloggedEmployeeReducer())
                dispatch(clearemployeeAccessTokenTokenReducer())
                navigate(USERROUTES.USERLOGIN);
            }
        } catch (err) {
            console.error("Error fetching role data", err);
        }
    };
    const handleBack = () => {
        navigate(USERROUTES.USERPROFILEINTRODUCTION);
    }
    return (
        <div><div
            className={`topbar-userTest d-flex align-items-center justify-content-between py-2 cmn-shadow shadow-sm`}
        >
            {/* LEFT — Logo + Sidebar Toggle */}
            <div className="d-flex align-items-center">
                <div
                    className="cursor-pointer"
                // onClick={() => setSidebarCollapse((prev) => !prev)}
                >
                    {/* {sidebarCollapse ? <SIDEBARMENU right={true} /> : <SIDEBARMENU />} */}
                </div>
                <img
                    src={LOGO_IMG}
                    alt="Logo"
                    className="full-logo"
                />
            </div>

            {/* CENTER — Project Name */}
            <div className="text-center flex-grow-1">
                <h5 className="m-0 fw-semibold ">Project Name / User Name</h5>
            </div>

            <div className=''>
                <img className='me-3 cursor-pointer ' src={USERBACK_ICON} alt='' onClick={handleBack} />
                <img className='cursor-pointer ' src={USERLOGOUT_ICON} alt='' onClick={handleLogout} />
            </div>

            {/* RIGHT — Admin Profile */}
            {/* <div
                className="position-relative d-flex align-items-center gap-2 cursor-pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowDropmenu((prev) => !prev);
                }}
            >
                <img
                    src="/ipam-website/assets/test-user.jpg"
                    alt="User"
                    height={45}
                    width={45}
                    className="rounded-circle"
                />
                <div className="d-md-block d-none text-white text-end">
                    <p className="fw-bold mb-0">Advantal</p>
                    <span className="text-dark small">Admin</span>
                </div>

                {showDropmenu && (
                    <div
                        className="topbar_dropmenu cmn-shadow"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <li>
                            <i className="bi bi-person-fill fs-5"></i>{" "}
                            <span className="text-offwhite">Account</span>
                        </li>
                        <li>
                            <i className="bi bi-gear-fill fs-5"></i>{" "}
                            <span className="text-offwhite">Setting</span>
                        </li>
                        <li onClick={handleLogout}>
                            <i className="bi bi-box-arrow-left fs-5"></i>{" "}
                            <span className="text-offwhite">Logout</span>
                        </li>
                    </div>
                )}
            </div> */}
        </div>
        </div>
    )
}

export default NewTopBar;